/**
 * Logic-only Handler: GiftWrapVisibilityManager
 * Toggles visibility for Gift Wrap addons and notes based on cart contents.
 */
class GiftWrapVisibilityManager {
    constructor() {
        this.subscriptions = [];
        this.init();
    }

    init() {
        // Ensure Minimog events exist before subscribing
        if (!window.MinimogEvents) return;

        // 1. Listen for cart updates (adding/removing items)
        const cartUpdate = window.MinimogEvents.subscribe(
            MinimogTheme.pubSubEvents.cartUpdate, 
            () => this.handleGiftWrap()
        );

        // 2. Listen for drawer opening (initial state check)
        const openCartDrawer = window.MinimogEvents.subscribe(
            MinimogTheme.pubSubEvents.openCartDrawer, 
            () => this.handleGiftWrap()
        );

        this.subscriptions.push(cartUpdate, openCartDrawer);
    }

    handleGiftWrap() {
        // Select the specific DOM elements to toggle
        const cartAddon = document.querySelector('.m-cart-addon');
        const wrappingNote = document.querySelector('.m-cart-drawer__gift-wrapping');
        
        // Look for the gift wrap item in the current DOM list
        const hasGiftItem = !!document.querySelector(".m-cart-item[data-product-type='gift-wrap']");

        
        // Fail gracefully if elements aren't found in the current view
        if (!cartAddon && !wrappingNote) return;
        
        // Determine the display style (block/flex) based on presence of gift wrap
        const displayStyle = hasGiftItem ? 'block' : 'none';
        
        if (cartAddon) cartAddon.style.display = displayStyle;
        if (wrappingNote) wrappingNote.style.display = displayStyle;
    }
}

// Initialize the background listener
new GiftWrapVisibilityManager();